<template>
  <section class="mx-auto max-w-6xl mt-8 sm:mt-12 space-y-4 p-4 lg:p-0">
    <slot/>
  </section>
</template>
